export enum QuestionTypes {
  unknown = 0,
  indicator = 1,
  effectiveness = 2
}
